import { useState } from 'react';
import { v4 as uuidV4 } from 'uuid';
import { StatusGroup } from '@/store/cases-board.store';
import { CaseStatus } from '@/api/apis/case';

export const useStatusGroups = ({ initialGroups }: { initialGroups: StatusGroup[] }) => {
  const [selectedStatuses, setSelectedStatuses] = useState<CaseStatus[]>([]);
  const [editingGroupId, setEditingGroupId] = useState<string>('');
  const [groups, setGroups] = useState<StatusGroup[]>(initialGroups ?? []);
  const [groupName, setGroupName] = useState<string>('');

  const addStatus = (status: CaseStatus) => {
    setSelectedStatuses((currStatuses) => [...currStatuses, status]);
  };

  const removeStatus = (status: CaseStatus) => {
    setSelectedStatuses((currStatuses) => currStatuses.filter((s) => s !== status));
  };

  const createGroup = () => {
    setGroups((existingGroups) => [...existingGroups, { id: uuidV4(), name: groupName, statuses: selectedStatuses }]);
    setGroupName('');
    setSelectedStatuses([]);
  };

  const editGroup = () => {
    setGroups((existingGroups) => {
      return existingGroups.map((g) =>
        g.id === editingGroupId ? { id: g.id, name: groupName, statuses: selectedStatuses } : g,
      );
    });
    setGroupName('');
    setEditingGroupId('');
    setSelectedStatuses([]);
  };

  const onGroupStatusDelete = (id: string, status: CaseStatus) => {
    setGroups((existingGroups) => {
      return existingGroups.map((g) => {
        if (g.id === id && g.statuses.length > 1) {
          return { ...g, statuses: g.statuses.filter((s) => s !== status) };
        }
        return g;
      });
    });
  };

  const onGroupDelete = (id: string) => {
    setGroups((prevGroups) => prevGroups.filter((g) => g.id !== id));
  };

  const onStartGroupEdit = (id: string, prevName: string, statuses: CaseStatus[]) => {
    setSelectedStatuses(statuses);
    setGroupName(prevName);
    setEditingGroupId(id);
  };

  return {
    addStatus,
    removeStatus,
    createGroup,
    editGroup,
    onGroupStatusDelete,
    onGroupDelete,
    onStartGroupEdit,
    setGroupName,
    groups,
    editingGroupId,
    selectedStatuses,
    groupName,
  };
};
